import api from './api';

export const blocksApi = {
  async getBlockByIdentifier(identifier) {
    const response = await api.get(`/blocks/get-block-by-identifier/${identifier}`);
    return response.data;
  }
};